"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletLinkConnector = void 0;
const schemas_1 = require("@dcl/schemas");
const walletlink_connector_1 = require("@web3-react/walletlink-connector");
const configuration_1 = require("../configuration");
const APP_NAME = 'Decentraland';
// Coinbase connector to connect a wallet with the Coinbase mobile wallet
class WalletLinkConnector extends walletlink_connector_1.WalletLinkConnector {
    constructor(chainId) {
        super({
            url: configuration_1.getRpcUrls(schemas_1.ProviderType.WALLET_LINK)[chainId],
            appName: APP_NAME,
            supportedChainIds: [chainId]
        });
    }
}
exports.WalletLinkConnector = WalletLinkConnector;
//# sourceMappingURL=WalletLinkConnector.js.map